import { Injectable } from '@angular/core';
import { DerivativeSummary } from '@interfaces/a-organizar/derivativeSummary';
import {
  NdfDemandsCalculationsFiltered,
  NdfDemandsCalculationsOperation,
} from '@interfaces/a-organizar/ndfDemandsCalculationsFiltered';
import { NdfOperationFilteredSummary } from '@interfaces/a-organizar/ndfOperationsFilteredSummary';

@Injectable({
  providedIn: 'root',
})
export class DerivativesSummaryDataService {
  /**
   * Maps the object NdfOperationFilteredSummary to object DerivativeSummary
   * @param operation An object type NdfOperationFilteredSummary
   * @return An object type DerivativeSummary
   */
  mapOperationFilteredToDerivativeSummary(
    operation: NdfOperationFilteredSummary
  ): DerivativeSummary {
    return {
      id: operation.id || '',
      company: operation.company || '',
      valueME: operation.notionalAmount || 0,
      notionalAmount: operation.notionalAmount || 0,
      dueAt: operation.dueAt || '',
      settlementDate: operation.settlementDate || '',
      reference: operation.reference || '',
      operationDate: operation.operationDate || '',
      userName: operation.userName || '',
      businessDaysCount: operation.businessDaysCount || 0,
      daysCount: operation.daysCount || 0,
      settlementNotional: operation.settlementNotional || 0,
      forwardRate: operation.forwardRate || 0,
      capValue: operation.capValue || 0,
      composition: operation.composition || '',
      financialStatus: operation.financialStatus || '',
      settlementRate: operation.settlementRate || 0,
      referenceExchangeRate: operation.referenceExchangeRate || 0,
      totalAmountRounded: operation.totalAmountRounded || 0,
      netAmountdRounded: operation.netAmountdRounded || 0,
      internationalCurrencyId: operation.internationalCurrencyId || '',
      withholdingTaxRounded: operation.withholdingTaxRounded || 0,
      incomeTaxPayableRounded: operation.incomeTaxPayableRounded || 0,
    };
  }

  /**
   * Maps the 2 objects to build an object type DerivativeSummary
   * @param company {string} The company name
   * @param demand An object type NdfDemandsCalculationsFiltered
   * @param operationToHire An object type NdfDemandsCalculationsOperation
   * @return An object type DerivativeSummary
   */
  mapDemandsToDerivativeSummary(
    company: string,
    demand: NdfDemandsCalculationsFiltered | null,
    operation: NdfDemandsCalculationsOperation
  ): DerivativeSummary | null {
    return {
      id: demand?.id || '',
      company: company,
      valueME: demand?.transactionValue || 0,
      notionalAmount: operation?.notionalAmount || 0,
      dueAt: operation?.dueAt || '',
      settlementDate: '',
      reference: demand?.reference || '',
      operationDate: operation?.operationDate || '',
      userName: 'Não informado',
      businessDaysCount: operation?.businessDaysCount || 0,
      daysCount: operation?.daysCount || 0,
      settlementNotional: 0,
      forwardRate: operation?.forwardRate || 0,
      capValue: operation?.capValue || 0,
      composition: operation?.composition || '',
      financialStatus: operation?.financialStatus || '',
      settlementRate: 0,
      referenceExchangeRate: operation?.referenceExchangeRate || 0,
      totalAmountRounded: 0,
      netAmountdRounded: 0,
      internationalCurrencyId: demand?.internationalCurrencyId || '',
      withholdingTaxRounded: 0,
      incomeTaxPayableRounded: operation?.incomeTaxPayableRounded || 0,
    };
  }
}
